import React, { memo } from 'react';
import PropTypes from 'prop-types';

const QuizHeaderComponent = ({ index, total, description }) => {
  const progress = Math.max(0, Math.min(100, (index / total) * 100));

  return (
    <div className="quiz-header">
      <div className="quiz-profile-card">
        <div className="quiz-profile-step">
          {index}/{total}
        </div>
        <div className="quiz-profile-content">
          <div className="quiz-profile-eyebrow">Creating your coffee profile</div>
          <div className="quiz-profile-copy">{description}</div>
          <div className="quiz-profile-progress" aria-label={`Quiz progress ${Math.round(progress)}%`}>
            <div className="quiz-profile-progress-fill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

QuizHeaderComponent.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  description: PropTypes.string,
};

QuizHeaderComponent.defaultProps = {
  description: "Answer a few quick questions and we'll find coffees that fit your taste.",
};

export const QuizHeader = memo(QuizHeaderComponent);
